import {
  ENewbuildingHousesActionTypes,
  ILayoutMetaRefreshCompleteAction,
  ILayoutMetaRefreshCompletePayload,
} from './types';
import { prepareJsonQuery } from '../../services/fetchOffers';
import { fetchResidentialComplexLayoutsCountSafe } from '../../services/fetchResidentialComplexLayoutsCount';
import { TThunkAction } from '../../types/redux';
import { newbuildingLayoutsOff } from '../newbuildingLayouts';
import { makeSearchLayout } from '../searchLayout';
import { jq } from 'shared/json_query';
import { actionGenerator } from 'shared/utils/redux';

const updateLayoutMeta: (params: ILayoutMetaRefreshCompletePayload) => ILayoutMetaRefreshCompleteAction =
  actionGenerator<ENewbuildingHousesActionTypes.META_REFRESH_COMPLETE, ILayoutMetaRefreshCompletePayload>(
    ENewbuildingHousesActionTypes.META_REFRESH_COMPLETE,
  );

interface IGetNewbuildingHousesOffersParams {
  houseIds: number[];
  newbuildingId: number;
}

export function getNewbuildingHousesOffers({
  houseIds,
  newbuildingId,
}: IGetNewbuildingHousesOffersParams): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { logger, config, httpApi } = context;
    const {
      currentLocation,
      results: { jsonQuery: prevJsonQuery },
    } = getState();

    const jsonQuery = jq(prevJsonQuery).setNewbuildingHouses(newbuildingId, houseIds);

    try {
      const layoutsCountMeta = await fetchResidentialComplexLayoutsCountSafe(
        { httpApi, logger, config },
        { jsonQuery: prepareJsonQuery({ jsonQuery, location: currentLocation }) },
      );

      dispatch(updateLayoutMeta({ layoutsCountMeta: layoutsCountMeta.offersCount }));

      if (layoutsCountMeta.offersCount === 0) {
        dispatch(newbuildingLayoutsOff());
      }

      dispatch(makeSearchLayout(jsonQuery));
    } catch (error) {
      logger.error(error);
    }
  };
}
